/**
 * @fileoverview
 * Collateral / ornament type display utilities.
 * Maps short codes to full display names (e.g. CHA -> CHAIN, BAN -> BANGLES).
 *
 * @version 1.0.0
 * @author KATALYST TEAM
 */

/**
 * Returns the full display name for a collateral ornament type code.
 * Uses switch on normalized (uppercase) code; unknown codes are returned as-is.
 */
export function getCollateralOrnamentDisplayName(code: string | null | undefined): string {
  const raw = (code ?? '').trim();
  if (raw === '') return raw;
  const key = raw.toUpperCase();
  switch (key) {
    case 'CHA':
      return 'CHAIN';
    case 'MWL':
      return 'MANGALSUTRA (WITH LKT)';
    case 'MOT':
      return 'MANGALSUTRA (WITHOUT LKT)';
    case 'FIN':
      return 'FINGER RING';
    case 'ERI':
      return 'EAR RING';
    case 'DRO':
      return 'DROP STUD';
    case 'STU':
      return 'STUD';
    case 'BRO':
      return 'BROAD BANGLE';
    case 'EAR':
      return 'EAR CHAIN';
    case 'BRA':
      return 'BRACELET';
    case 'BAJ':
      return 'BAJUBAND';
    case 'BAN':
      return 'BANGLES';
    case 'CWL':
      return 'CHAIN WITH LOCKET';
    case 'KAD':
      return 'KADA';
    case 'LOC':
      return 'LOCKET';
    case 'MAN':
      return 'MANI CHAIN';
    case 'MAT':
      return 'MATTI';
    case 'NEB':
      return 'NECKLACE - BROKEN';
    case 'NEC':
      return 'NECKLACE';
    case 'NOS':
      return 'NOSE RING';
    case 'OTH':
      return 'OTHERS';
    case 'RING':
      return 'RING';
    case 'RUBY':
      return 'RUBY';
    case 'TIK':
      return 'TIKKA';
    default:
      return raw;
  }
}
